import { PageHeader } from "../../commons/component/PageHeader/PageHeader";
import MedicalSpecialtiesListComponent from "../../components/MedicalSpecialties/MedicalSpecialties.List/MedicalSpecialtiesList.Component";

const MoreConfigurationsPage = () => {

    return (
        <>
            <PageHeader title={"Configuraciones adicionales"} />
            <div className="header">
                <h2>Especialidades</h2>
            </div>
            <div className="Section">
                <MedicalSpecialtiesListComponent />
            </div>
        </>
    )
}

export default MoreConfigurationsPage;
